var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 22,
    viewBox: "0 0 11 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.57 11.009H7.25367V22H2.3373V11.009H0V7.12494H2.3373V4.61303C2.3373 2.81207 3.26005 0 7.29888 0L10.94 0.012864V3.7863H8.29545C8.14842 3.77904 8.00148 3.8021 7.86516 3.85382C7.72885 3.90554 7.60653 3.98463 7.50697 4.08545C7.4074 4.18626 7.33306 4.30629 7.28927 4.43694C7.24548 4.56759 7.23332 4.70562 7.25367 4.84115V7.12494H11L10.57 11.009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.313687d3c7ca6d607b4c089ef4670949.svg";
export { ForwardRef as ReactComponent };